const admin = {
  dashboard: {
    title: "Tableau de bord",
    welcome: "Bienvenue dans l'administration",
    selectModule: "Sélectionnez un module pour gérer votre contenu",
    modules: {
      projects: "Gérer vos projets portfolio",
      blog: "Gérer vos articles de blog",
      experiences: "Gérer vos expériences professionnelles",
      skills: "Gérer vos expertises et soft skills",
      activities: "Gérer vos conférences et meetups",
      technologies: "Gérer votre stack technique",
      cases: "Gérer vos études de cas",
      messages: "Voir les messages de contact",
    },
    stats: {
      projects: "Projets",
      experiences: "Expériences",
      skills: "Compétences",
      messages: "Messages",
    },
  },

  sections: {
    projects: "Projets",
    experiences: "Expériences",
    technologies: "Technologies",
    skills: "Compétences",
    blog: "Blog",
    activities: "Activités",
    cases: "Cas clients",
    services: "Services",
    labs: "Labs",
    messages: "Messages",
  },

  actions: {
    create: "Créer",
    edit: "Modifier",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    publish: "Publier",
    unpublish: "Dépublier",
    back: "Retour",
    confirm: "Confirmer",
    logout: "Déconnexion",
    reply: "Répondre",
    close: "Fermer",
  },

  labels: {
    title: "Titre",
    description: "Description",
    content: "Contenu",
    excerpt: "Extrait",
    category: "Catégorie",
    status: "Statut",
    published: "Publié",
    draft: "Brouillon",
    date: "Date",
    order: "Ordre",
    company: "Entreprise",
    role: "Poste",
    startDate: "Date de début",
    endDate: "Date de fin",
    isCurrent: "Poste actuel",
    name: "Nom",
    level: "Niveau",
    yearsExperience: "Années d'expérience",
    actions: "Actions",
    slug: "Slug",
    client: "Client",
    coverImageUrl: "URL Image de couverture",
    email: "Email",
    phone: "Téléphone",
    subject: "Sujet",
    read: "Lu",
    unread: "Non lu",
    skills: "Compétences",
    technologies: "Technologies",
    select: "Sélectionner...",
  },

  messages: {
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
    confirmDeleteTitle: "Confirmer la suppression",
    confirmDeleteMessage:
      'Êtes-vous sûr de vouloir supprimer ce message de "{{name}}" ?',
    slugHelper: "Identifiant unique pour l'URL (ex: mon-article)",
    messageFrom: "Message de {{name}}",
    saveSuccess: "Enregistrement réussi",
    saveError: "Erreur lors de l'enregistrement",
    deleteSuccess: "Suppression réussie",
    deleteError: "Erreur lors de la suppression",
    loading: "Chargement des données...",
    noData: "Aucune donnée trouvée",
  },

  translations: {
    title: "Traductions",
    french: "Français",
    english: "Anglais",
    tabs: {
      fr: "Français",
      en: "Anglais",
    },
  },

  skills: {
    categories: {
      aiMl: "IA / ML",
      backend: "Backend",
      frontend: "Frontend",
      cloud: "Cloud",
      other: "Autre",
    },
    levels: {
      beginner: "Débutant",
      intermediate: "Intermédiaire",
      advanced: "Avancé",
      expert: "Expert",
    },
  },

  technologiesMeta: {
    categories: {
      frontend: "Frontend",
      backend: "Backend",
      language: "Langage de programmation",
      database: "Base de données",
      devops: "DevOps",
      mobile: "Mobile",
      aiMl: "IA / ML",
      cloud: "Cloud",
      integration: "Intégration / API / MCP",
      tools: "Outils",
      other: "Autre",
    },
    proficiency: {
      beginner: "Débutant",
      intermediate: "Intermédiaire",
      advanced: "Avancé",
      expert: "Expert",
    },
  },

  casesMeta: {
    clientName: "Nom du client",
    caseLabel: "Type de cas",
  },
};

export default admin;
